(() => {
  if (window.CartCheckoutValidation) return;

  const checkoutSelector = 'button[name="checkout"], input[name="checkout"]';
  const reasons = new Map();

  const getTermsCheckbox = button => {
    const container = button.closest('sidebar-drawer, .cart-section') || document;
    return container.querySelector('terms-checkbox input[type="checkbox"]');
  };

  const updateButtons = () => {
    const blocked = reasons.size > 0;
    const title = Array.from(reasons.values()).filter(Boolean).join(' ');

    document.querySelectorAll(checkoutSelector).forEach(button => {
      if (blocked) {
        if (button.dataset.cartValidationBlocked !== 'true') {
          const termsCheckbox = getTermsCheckbox(button);
          const disabledForTerms = termsCheckbox && !termsCheckbox.checked;
          button.dataset.cartValidationPreviouslyDisabled = button.disabled && !disabledForTerms ? 'true' : 'false';
        }

        button.dataset.cartValidationBlocked = 'true';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        if (title) button.setAttribute('title', title);
        return;
      }

      if (button.dataset.cartValidationBlocked === 'true') {
        const termsCheckbox = getTermsCheckbox(button);
        button.disabled = termsCheckbox
          ? !termsCheckbox.checked
          : button.dataset.cartValidationPreviouslyDisabled === 'true';
        button.removeAttribute('data-cart-validation-blocked');
        button.removeAttribute('data-cart-validation-previously-disabled');
        button.removeAttribute('aria-disabled');
        button.removeAttribute('title');
      }
    });
  };

  window.CartCheckoutValidation = {
    setReason(key, active, message = '') {
      if (active) reasons.set(key, message);
      else reasons.delete(key);
      updateButtons();
    },
    hasReason(key) {
      return reasons.has(key);
    },
    update: updateButtons
  };

  document.addEventListener('change', event => {
    if (event.target.matches('terms-checkbox input[type="checkbox"]')) {
      window.requestAnimationFrame(updateButtons);
    }
  }, true);
})();
